import { message } from 'antd';
import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { getCityList } from '@/apis/commonApi';

const model = {
  state: {
    citys: [],
    settleData: {},
    ruleData: {},
    subShops: {},
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { shopAgent }, getState }: { dispatch: any; getState: any }) => ({
    // 获取省市信息
    async getCities() {
      const data = await getCityList();
      shopAgent.setState({
        cities: data.map((province) => {
          return {
            title: province.label,
            value: province.value,
            key: province.value,
            children: province.children?.map((city) => {
              return {
                title: city.label,
                value: city.value,
                key: city.value,
              };
            }),
          };
        }),
      });
      return data;
    },
    // 商户数据查询
    async postValuationQuery(shopId: number) {
      const data = await fetch('/saasmerchant/web/fslogistics/shop/valuationquery', {
        type: 'POST',
        useJson: true,
        params: { shopId },
      });
      if (data) {
        shopAgent.setState({ settleData: data });
        shopAgent.setState({ subShops: data.subShops });
      }
    },
    clearSettleData() {
      shopAgent.setState({ settleData: {} });
    },
    // 商户数据保存
    async postShopUpdate(params: any, callback: Function) {
      const data = await fetch('/saasmerchant/web/fslogistics/shop/shopupdate', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        message.success('商户数据保存成功');
        callback();
      }
    },
    // 计价规则生效/失效
    async postValuationStatusUpdate(params: any) {
      const data = await fetch('/saasmerchant/web/fslogistics/valuationstatusupdate', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        if (params.ruleStatus) {
          message.success('计价规则失效成功');
        } else {
          message.success('计价规则生效成功');
        }
        shopAgent.postValuationQuery(params.shopId);
      }
    },
    // 修改/新建规则
    async postValuationRule(params: any, callback: Function) {
      const data = await fetch('/saasmerchant/web/fslogistics/shop/valuationcu', {
        type: 'POST',
        useJson: true,
        params: filterNull(params),
      });
      if (data) {
        callback();
      }
    },
    setRuleData(ruleData: any) {
      shopAgent.setState({ ruleData });
    },
  }),
};

export default model;
